import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import RedFlagType from '../../entities/redFlagType';
import RedFlag from '../../entities/redFlag';
export function deleteRedFlagType(redFlagType: RedFlagType, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = redFlagType.id;}
const _work = workingSet();
store.getState().redFlags.getMappingFor('redFlagTypeId', redFlagType.id).filter(redFlagTemp => redFlagTemp.status !== 'D').forEach(redFlagTemp => {
const _redFlag = ((_work.get('redFlag:' + redFlagTemp.id) ?? redFlagTemp) as RedFlag).clone();
_redFlag.status = 'D';
_redFlag.addedOn = newHRTimestamp();
_redFlag.addedBy = getCurrentUserId();
_redFlag.importSource = targetImportSource;
_redFlag.importId = mergeId;

_work.set('redFlag:' + _redFlag.id, _redFlag);
store.dispatch(Actions.RedFlagActions.saveRedFlagQueue(_redFlag));
});



redFlagType.status = 'D';
redFlagType.addedOn = newHRTimestamp();
redFlagType.addedBy = getCurrentUserId();
redFlagType.importSource = targetImportSource;
redFlagType.importId = mergeId;
store.dispatch(Actions.RedFlagTypeActions.removeRedFlagTypeQueue(redFlagType));
}
export function replaceRedFlagType(redFlagType: RedFlagType, replaceWith: RedFlagType, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = redFlagType.id;}
const _work = workingSet();
store.getState().redFlags.getMappingFor('redFlagTypeId', redFlagType.id).filter(redFlagTemp => redFlagTemp.status !== 'D').forEach(redFlagTemp => {
const _redFlag = ((_work.get('redFlag:' + redFlagTemp.id) ?? redFlagTemp) as RedFlag).clone();
_redFlag.status = 'U';
_redFlag.addedOn = newHRTimestamp();
_redFlag.addedBy = getCurrentUserId();
_redFlag.importSource = targetImportSource;
_redFlag.importId = mergeId;
if (_redFlag.redFlagTypeId === redFlagType.id) {
_redFlag.redFlagTypeId = replaceWith.id;

}
_work.set('redFlag:' + _redFlag.id, _redFlag);
store.dispatch(Actions.RedFlagActions.saveRedFlagQueue(_redFlag));
});



return redFlagType;
}
export function deleteImpactRedFlagType(redFlagType: RedFlagType) {
const impacts: string[] = [];
const state = store.getState();
const redFlagRedFlagTypeIdImpact = state.redFlags.getMappingFor('redFlagTypeId', redFlagType.id).filter(redFlag => redFlag.status !== 'D');
redFlagRedFlagTypeIdImpact.forEach(() => impacts.push('redFlags'));



return util.countDistinct(impacts);
}
